/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./alert-message.vue?vue&type=template&id=09e11bd0&scoped=true&"
import script from "./alert-message.vue?vue&type=script&lang=js&"
export * from "./alert-message.vue?vue&type=script&lang=js&"
import style0 from "./alert-message.vue?vue&type=style&index=0&id=09e11bd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e11bd0",
  null
  
)

export default component.exports